import { OnboardingTarget, onboardingTarget } from "../onboarding/onboardingTargets";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import {
  selectIsPlaying,
  selectSelectedTake,
  setImageBounds,
  setViewportBounds,
} from "../../app/slices/TrainingSlice";
import "./TrainingBubbleViewport.css";

import { Viewer } from "@photo-sphere-viewer/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Pi360Viewer from "../../components/Pi360Viewer";
import { useAssetPreview } from "../../hooks/AssetPreviewHook";
import { calculateContainedImageBounds } from "./ImageBounds";
import TrainingPreviewOverlay from "./TrainingPreviewOverlay";

export default function TrainingBubbleViewport() {
  const dispatch = useDispatch();
  const imgRef = useRef<HTMLImageElement>(null);
  const ref360 = React.createRef<Viewer>();
  const isPlaying = useSelector(selectIsPlaying);
  const selectedTake = useSelector(selectSelectedTake);
  const containerRef = useRef<HTMLDivElement>(null);
  // const thumbnailUrl = selectAssetThumbnailUrlFromFolders(
  //   useSelector(selectAllFolders),
  //   selectedTake?.assetId
  // );
  const { getAssetPreview } = useAssetPreview(selectedTake?.assetId);
  const onWindowResize = () => {
    onLoad();
  };

  useEffect(() => {
    // 360 stuff
    if (ref360.current) {
      ref360.current.setPanorama(getAssetPreview());

      if (!selectedTake?.display360) {
        ref360.current?.hideError();
        ref360.current?.stopAnimation();
        ref360.current?.destroy();
      }
    }
  }, [selectedTake, ref360]);

  // useEffect(() => {
  //   // window resize
  //   window.addEventListener("resize", onWindowResize);

  //   return () => window.removeEventListener("resize", onWindowResize);
  // });

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      onWindowResize();
    });
    if (containerRef.current) resizeObserver.observe(containerRef.current!);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  // resize after stop playing -> the transition messes up the calculations
  useEffect(() => {
    if (!isPlaying) {
      const waitResize = async () => {
        await delay(150);
        onWindowResize();
      };

      waitResize();
    }
  }, [isPlaying]);

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const onLoad = async () => {
    // get actual image size
    if (imgRef.current) {
      var previewUrl = getAssetPreview();
      let img = new Image();
      img.src = previewUrl === undefined ? "" : previewUrl!;
      img.onload = async () => {
        var b = imgRef.current?.getBoundingClientRect();
        if (b) {
          const imgBounds = calculateContainedImageBounds(
            img.width,
            img.height,
            b.width,
            b.height
          );

          dispatch(
            setViewportBounds({
              x: b.x,
              y: b.y,
              width: b.width,
              height: b.height,
            })
          );
          dispatch(setImageBounds(imgBounds));
        }
      };
    }
  };

  const viewer360 = <Pi360Viewer container="trainingbubbleviewport-root" />;

  const overlay = selectedTake?.display360 ? (
    <div></div>
  ) : (
    <TrainingPreviewOverlay />
  );

  const normalImage = (
    <img
      className="trainingbubbleviewport-img"
      src={getAssetPreview()}
      ref={imgRef}
      onLoad={onLoad}
      alt=""
    />
  );

  const content = selectedTake?.display360 ? viewer360 : normalImage;

  return (
    <div
      className="trainingbubbleviewport-root"
      ref={containerRef}
      {...onboardingTarget(OnboardingTarget.Editor360Viewport)}
    >
      {content}
      {overlay}
    </div>
  );
}
